module.exports = {
    "dismiss": `Descartar`
};


//# sourceMappingURL=es-ES.main.js.map
